module.exports = __webpack_public_path__ + "static/media/canvas-collage.53efe1b1.png";